import React from "react";
import { Box, Chip, Container, Paper, Typography } from "@mui/material";
import PublicMarketingShell from "../components/PublicMarketingShell";
import {
  publicCardHoverSx,
  publicCardSx,
  publicHeroChipSx,
  publicTitleSx,
} from "../constants/publicMarketingTheme";

const cards = [
  [
    "Accounting Automation",
    "Auto-generate downstream accounting records from source module activity.",
  ],
  [
    "Multi-Module Coverage",
    "Accounting, HR, Procurement, Sales, Inventory, and Marketing in one ecosystem.",
  ],
  [
    "Role & Permission Control",
    "Fine-grained RBAC from organization to module level.",
  ],
  [
    "Live Updates",
    "WebSocket-powered status updates for better team alignment.",
  ],
  [
    "Subscription Gating",
    "Enable only modules your organization subscribes to.",
  ],
  [
    "Audit-Friendly Flows",
    "Consistent records and traceability for operational decisions.",
  ],
];

const FeaturesPage = () => (
  <PublicMarketingShell>
    <Container maxWidth="lg">
      <Chip label="Why teams choose us" sx={publicHeroChipSx} />
      <Typography variant="h3" sx={{ ...publicTitleSx, mb: 3 }}>
        Platform Features
      </Typography>
      <Box
        sx={{
          animation: "fadeUp 650ms ease-out",
          display: "flex",
          flexWrap: "wrap",
          gap: 2.5,
        }}
      >
        {cards.map(([title, desc]) => (
          <Box key={title} sx={{ flex: "1 1 320px", minWidth: 0 }}>
            <Paper
              sx={{
                ...publicCardSx,
                ...publicCardHoverSx,
                p: 2.5,
                height: "100%",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                {title}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {desc}
              </Typography>
            </Paper>
          </Box>
        ))}
      </Box>

      <Paper
        sx={{
          ...publicCardSx,
          mt: 3,
          p: 3,
          animation: "fadeUp 850ms ease-out",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
          Built for real operational flow
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          From subscription gating to cross-module posting, every feature is
          designed to support how modern organizations actually operate.
        </Typography>
      </Paper>
    </Container>
  </PublicMarketingShell>
);

export default FeaturesPage;
